<template>
  <div class="materials-blocks">
    <div class="main-title">
      <h2>
        <span>большое комьюнити</span> для&nbsp;родителей и&nbsp;учеников
      </h2>
    </div>

    <div class="materials-blocks__items">
      <div class="materials-blocks__block materials-blocks__block--support">
        <h6 class="materials-blocks__block_title">
          комьюнити для&nbsp;родителей и&nbsp;учеников
        </h6>
        <p class="materials-blocks__block_text">
          место для&nbsp;общения, обмена опытом и&nbsp;поддержки 24/7
        </p>

        <div class="materials-blocks__block_soc">
          <a
            href="https://t.me/synergyschool"
            target="_blank"
          >
            <img
              src="/v2/school-new/support/telegram.svg"
              alt="telegram"
            >
          </a>
          <a
            href="https://vk.com/synergyonlineschool"
            target="_blank"
          >
            <img
              src="/v2/school-new/support/vk.svg"
              alt="vk"
            >
          </a>
        </div>
      </div>

      <div class="materials-blocks__block materials-blocks__block--care">
        <h6 class="materials-blocks__block_title">
          нас&nbsp;читают родители и&nbsp;дети со&nbsp;всего мира
        </h6>

        <div class="materials-blocks__block_countries">
          <img
            src="/v2/school-university/reviews/rus.png"
            alt="Russia"
          >
          <img
            src="/v2/school-university/reviews/bra.png"
            alt="Brazil"
          >
          <img
            src="/v2/school-university/reviews/arg.png"
            alt="Argentina"
          >
          <img
            src="/v2/school-university/reviews/tur.png"
            alt="Turkey"
          >
          <img
            src="/v2/school-university/reviews/indo.png"
            alt="Indonesia"
          >
          <img
            src="/v2/school-university/reviews/indi.png"
            alt="India"
          >
          <img
            src="/v2/school-university/reviews/gb.png"
            alt="Great britain"
          >
          <img
            src="/v2/school-university/reviews/kaz.png"
            alt="Kazakhstan"
          >

          <span>и еще более +30&nbsp;стран</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MaterialsBlocks',
};
</script>

<style scoped lang="scss">

.materials-blocks {
  position: relative;

  .main-title {
    max-width: calc(var(--scale) * 1065);
    margin-bottom: calc(var(--scale) * 40);
  }

  .materials-blocks__items {
    height: calc(var(--scale) * 493);
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 1.25rem / 2));
    gap: 1.25rem;

    @include media-down($size-tablet) {
      grid-template-columns: repeat(2, calc(50% - 0.4rem));
      grid-template-rows: calc(var(--scale) * 512) calc(var(--scale) * 512);
      gap: 0.8rem;
    }

    @include media-down($size-mobile) {
      height: auto;
      grid-template-columns: 100%;
      grid-template-rows: repeat(2, 51.2rem);
    }
  }

  .materials-blocks__block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2.5rem;
    position: relative;

    background-color: #FFFFFF;
    background-repeat: no-repeat;
    border-radius: 2.5rem;

    @include media-down($size-tablet) {
      padding: 1.6rem 1.4rem 1.6rem 1.6rem;
    }

    .materials-blocks__block_title {
      margin-bottom: 0.75rem;

      font-weight: 500;
      font-size: 3rem;
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom: 0.8rem;
        font-size: 4rem;
        letter-spacing: -0.04em;
      }
    }

    &--support {
      background-image: url("/v2/school-new/support/3.webp");
      background-position: bottom right;
      background-size: auto 100%;

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/support/3-tablet.webp");
        background-size: 100% auto;
      }

      .materials-blocks__block_title {
        max-width: calc(var(--scale) * 405);
      }

      .materials-blocks__block_text {
        max-width: calc(var(--scale) * 435);

        font-style: normal;
        font-weight: 500;
        font-size: calc(var(--scale) * 26);
        line-height: 120%;
        color: #A7ABAC;

        @include media-down($size-tablet) {
          font-size: 1.8rem;
          line-height: 110%;
        }
      }

      .materials-blocks__block_soc {
        margin-top: auto;
        display: flex;
        gap: calc(var(--scale) * 8);

        img {
          width: calc(var(--scale) * 72);

          @include media-down($size-tablet) {
            width: calc(var(--scale) * 56);
          }
        }
      }
    }

    &--care {
      background-image: url("/v2/school-new/choose/world.webp");
      background-position: bottom calc(-1 * var(--scale) * 95) center;
      background-size: 90% auto;

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/choose/world-tablet.webp");
      }

      @include media-down($size-mobile) {
        background-image: url("/v2/school-new/choose/world-tablet.webp");
        background-size: 100% auto;
        background-position: bottom center;
      }

      .materials-blocks__block_title {
        max-width: calc(var(--scale) * 595);
      }

      .materials-blocks__block_countries {
        margin-top: calc(var(--scale) * 20);
        display: flex;
        align-items: center;

        @include media-down($size-tablet) {
          margin-top: calc(var(--scale) * 16);
        }

        img {
          position: relative;
          width: calc(var(--scale) * 46);
          aspect-ratio: 1/1;

          border: calc(var(--scale) * 1) solid #ECEDF0;
          border-radius: calc(var(--scale) * 100);
          margin-right: calc(-1  * var(--scale) * 6);
          outline: calc(var(--scale) * 2) solid #ffffff;

          @include media-down($size-tablet) {
            width: calc(var(--scale) * 32);
          }

          &:nth-of-type(1) { z-index: 7; }
          &:nth-of-type(2) { z-index: 6; }
          &:nth-of-type(3) { z-index: 5; }
          &:nth-of-type(4) { z-index: 4; }
          &:nth-of-type(5) { z-index: 3; }
          &:nth-of-type(6) { z-index: 2; }
          &:nth-of-type(7) { z-index: 1; }
          &:nth-of-type(8) { z-index: 0; }
        }

        span {
          margin-left: calc(var(--scale) * 25);

          font-weight: 400;
          font-size: calc(var(--scale) * 20);
          line-height: 130%;
          color: #02120F;

          @include media-down($size-tablet) {
            margin-left: 1.4rem;
            font-weight: 500;
            font-size: 1.4rem;
            max-width: calc(var(--scale) * 96);
          }
        }
      }
    }
  }
}

</style>
